<template>
<Draggable itemKey="id"  :list="SectionList" tag="div" handle=".handle" :group="{ name: 'g1' }"  :options="options" :onEnd="onEndDrag" :move="OnDragEnd" :class="ClassLevel" :animation="150" ghostClass="opacity-50">
    <template #item="{element}">
        <div class="position-relative" >
            <div
                class="d-flex small boq-section-row"
                :class="`boq-section-row--level-${element.level}`"
            >
                <div :class="{ 'handle' : !IsApproved }" class="p-2 border border-end-0 border-top-0 text-center" :style="{width: BoqBuilderColumSizes.HANDLE}">
                    <i class="fa-solid fa-up-down-left-right" v-if="!IsApproved"></i>
                    <span v-else>{{ReferenceIndex !== undefined ? GetReferenceLetter(ReferenceIndex) + "-" : ""}}{{ element.label }}</span>
                </div>
                <div class="p-2 border border-end-0 border-top-0 boq-section-row__description" :style="{width: BoqBuilderColumSizes.DESCRIPTION}">
                    <span class="text-primary fw-bold text-capitalize boq-section-row__name" role="button" v-if="!IsApproved"
                    data-bs-toggle="modal" data-bs-target="#RenameSectionModal" @click="OpenRename(element)"
                    >{{ element.name }}</span>
                    <span class="fw-bold text-capitalize boq-section-row__name" v-else> {{ element.name }}</span>
                </div>
                <div class=" p-2 border border-end-0 border-top-0 text-end " :title="element.expectedAmount ? $t('Estimate Amount') : ''" :class="{'text-info fw-light' : element.expectedAmount , 'text-danger' : element.sum?.costTotal < 0}" :style="{width: BoqBuilderColumSizes.COST_TOTAL}">
                    {{ element.sum  ? ReformatNumber(element.sum.costTotal) : ''}}
                </div>
                <div class=" p-2 border border-end-0 border-top-0 text-end " :title="element.expectedAmount ? $t('Estimate Amount') : ''" :class="{'text-info fw-light' : element.expectedAmount, 'text-danger' : element.sum?.sellTotal < 0}" :style="{width: BoqBuilderColumSizes.SELL_TOTAL}">
                    {{ element.sum  ? ReformatNumber(element.sum.sellTotal) : ''}}
                </div>
                <div class=" p-2 border border-end-0 border-top-0 text-end " :title="element.expectedAmount ? $t('Estimate Amount') : ''" :class="{'text-info fw-light' : element.expectedAmount, 'text-danger' : element.sum?.gp < 0}" :style="{width: BoqBuilderColumSizes.GP}">
                    {{ element.sum  ? ReformatNumber(element.sum.gp) : ''}}
                </div>
                <div class=" p-2 border border-end-0 border-top-0 text-end " :title="element.expectedAmount ? $t('Estimate Amount') : ''" :class="{'text-info fw-light' : element.expectedAmount, 'text-danger' : element.sum?.gpPercentage < 0}" :style="{width: BoqBuilderColumSizes.GP_PERCENTAGE}">
                    {{ element.sum  ? ReformatNumber(element.sum.gpPercentage,0,2) + '%' : ''}}
                </div>
                <div class=" p-2 border border-top-0" :style="{width: BoqBuilderColumSizes.ACTIONS}">
                    <router-link v-if="(element.level==2 && element.childs.length==0) || element.level==3" 
                    :to="{name : breakdownTo.name ,params : {id : breakdownTo.id, boqId : breakdownTo.boqId, parent : element.id}}" 
                    class="fw-bold text-primary text-decoration-none small me-1">
                        <i class="fa-solid fa-list"></i>  {{ $t('Breakdown') }}
                    </router-link> 
                    
                    <span v-if="CanProcureSection(element) && !element.forProcurement && !IsQuotationApproved && !IsAllChildrenForProcure(element)">
                        <small class="fw-bold text-primary now-wrap me-1"  @click="ProcureSection(element,Parent)" role="button">
                            <i class="fa-solid fa-cubes"></i> {{ $t('Procure') }}
                        </small>
                    </span>
                    <span v-else-if="element.forProcurement || IsQuotationApproved || IsAllChildrenForProcure(element)">
                        <small class="fw-bold text-success now-wrap me-1">
                            <i class="fa-solid fa-check"></i> {{ $t('In Procurement') }}
                        </small>
                    </span>


                    <span v-if="(element.level==1 || element.level==2) && !IsApproved && !element.forProcurement">
                        <small class="fw-bold text-success me-1 now-wrap"  role="button"  v-if="(element.level==2 && !element.sum) || element.level==1"  
                         data-bs-toggle="modal" data-bs-target="#BoQAddSubSectionModal"
                        @click="OpenAddNewSubSection(element)">
                            <i class="fa-solid fa-plus"></i> {{ $t('Section') }} 
                        </small>
                        <small class="fw-bold text-primary now-wrap me-1" v-if="element.level==2 && element.childs.length==0" @click="OpenMarkUp(element)" 
                        data-bs-toggle="modal" data-bs-target="#BoQMarkUpUpdateModal"
                        role="button">
                            <i class="fa-solid fa-money-bill-trend-up"></i> {{ $t('Mark Up') }} 
                        </small>
                        <small class="fw-bold text-danger now-wrap"  @click="DeleteMain(element,Parent)" role="button">
                            <i class="fa-solid fa-trash-can"></i> {{ $t('Delete') }} 
                        </small>
                    </span>
                    <span v-if="element.level==3 && !IsApproved && !element.forProcurement">
                        <small class="fw-bold text-primary now-wrap me-1" @click="OpenMarkUp(element)"
                        data-bs-toggle="modal" data-bs-target="#BoQMarkUpUpdateModal"
                        role="button">
                            <i class="fa-solid fa-money-bill-trend-up"></i> {{ $t('Mark Up') }} 
                        </small>
                        <small class="fw-bold text-danger now-wrap" @click="DeleteMain(element, Parent)"  role="button">
                            <i class="fa-solid fa-trash-can"></i> {{ $t('Delete') }}
                        </small>
                    </span>
                </div>
            </div>
            <BoqSectionRow v-if="element.level!=0" :SectionList="element.childs" :Level="Level + 1"
            :OpenRename="OpenRename" :OpenAddNewSubSection="OpenAddNewSubSection" :DeleteMain="DeleteMain" :ToObject="ToObject"
            :Parent="element" :OnEnd="OnEnd" :BoqItem="BoqItem" :OpenMarkUp="OpenMarkUp" :IsApproved="IsApproved" :ProcureSection="ProcureSection"
            :ReferenceIndex="ReferenceIndex" :IsQuotationApproved="IsQuotationApproved" :CanProcureSection="CanProcureSection"></BoqSectionRow>
            <div class="d-flex small fw-bold bg-light boq-section-subtotal-row" v-if="element.childs.length!=0">
                <div class="  p-2 border border-end-0 border-top-0" :style="{width: BoqBuilderColumSizes.HANDLE}">
                </div>
                <div class=" text-end p-2 border border-end-0 border-top-0" :style="{width: BoqBuilderColumSizes.DESCRIPTION}">
                    <span class="fw-bold text-capitalize" :class="{'pe-5' : Level!=1}">{{ $t('Sub Total Of') }} {{ element.name }}</span>
                </div>
                <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.COST_TOTAL}" :class="{'text-danger' : element.subTotal?.costTotal < 0}">
                    {{ ReformatNumber(element.subTotal?.costTotal) }}
                </div>
                <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.SELL_TOTAL}" :class="{'text-danger' : element.subTotal?.sellTotal < 0}">
                    {{ ReformatNumber(element.subTotal?.sellTotal) }}
                </div>
                <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.GP}" :class="{'text-danger' : element.subTotal?.gp < 0}">
                    {{ ReformatNumber(element.subTotal?.gp) }}
                </div>
                <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.GP_PERCENTAGE}" :class="{'text-danger' : element.subTotal?.gpPercentage < 0}">
                    {{ ReformatNumber(element.subTotal?.gpPercentage,0,2) }}%
                </div>
                <div class=" p-2 border border-top-0" :style="{width: BoqBuilderColumSizes.ACTIONS}">
                </div>
            </div>
        </div>
    </template>  
</Draggable>
</template>

<style scoped>
.boq-section-row {
    position: relative;
    min-height: 2.5rem;
    transition: background-color .15s ease;
}

.boq-section-row--level-1 {
    border-top: .3rem solid #fff;
    background: #faf7f4;
}

.boq-section-row--level-1:hover {
    background: #f7f1ec;
}

.boq-section-row--level-2 {
    background: #fff;
}

.boq-section-row--level-3 {
    background: #fff;
}

.boq-section-row--level-2:hover,
.boq-section-row--level-3:hover {
    background: #fcfaf8;
}

.boq-section-row__description {
    display: flex;
    align-items: center;
    min-width: 0;
}

.boq-section-row__name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.boq-section-row--level-1 .boq-section-row__name {
    color: #2f2925 !important;
    font-size: .78rem;
    font-weight: 700 !important;
}

.boq-section-row--level-2 .boq-section-row__name,
.boq-section-row--level-3 .boq-section-row__name {
    color: #24344d !important;
    font-weight: 600 !important;
}

.boq-section-row--level-2 .boq-section-row__name {
    margin-left: 1.35rem;
}

.boq-section-row--level-3 .boq-section-row__name {
    margin-left: 2.7rem;
}

.boq-section-subtotal-row {
    border-bottom: 1px solid #dfd7d1;
    background: #f4f1ee !important;
    color: #2f2925;
}

.handle{
    cursor: move;
}
.opacity-50{
    opacity: .5 !important;
}
.now-wrap{
    white-space: nowrap;
}
</style>
<script>
import Draggable from 'vuedraggable'
import BoqSectionRow from '@/components/boq/BoqSectionRow.vue'
import {ReformatNumber, GetReferenceLetter, BoqBuilderColumSizes} from '@/helpers/utilities.js'
export default{
    name : 'BoqSectionRow',
    mounted(){
        const self = this
        if(self.ToObject){
            self.breakdownTo = {
                name : 'HleBoqBuilderBreakdown',
                params : {
                    id : self.ToObject.id,
                    boqId : self.ToObject.boqId,
                }
            }
        }
        else{
            self.breakdownTo = {name : 'BoqBuilderBreakdown',params : {id : self.BoqItem._id}}
        }
    },
    computed : {
        ClassLevel(){
            if(this.Level==1){
                return 'parent'
            }
            else if(this.Level==2){
                return 'child'
            }
            else if(this.Level==3){
                return 'last'
            }

            return ''
        },
    },
    components : {
        Draggable, BoqSectionRow
    },
    props : {
        Parent : {
            type : Object,
            default : ()=>{}
        },
        SectionList : {
            type : Array,
        },
        Level : {
            type : Number,
        },
        OpenRename : {
            type : Function,
        },
        OpenAddNewSubSection : {
            type : Function,
        },
        DeleteMain : {
            type : Function,
        },
        ProcureSection : {
            type : Function,
        },
        CanProcureSection : {
            type : Function,
            // Bidding reuses this table without procurement actions.
            default : () => false,
        },
        OnEnd : {
            type : Function,
        },
        OpenMarkUp : {
            type : Function,
        },
        BoqItem : {
            type : Object,
            default : ()=>{}
        },
        IsApproved :{
            type : Boolean,
            default : false
        },
        IsQuotationApproved :{
            type : Boolean,
            default : false
        },
        ToObject : {
            type : Object,
            default : ()=>null
        },
        ReferenceIndex: {
            type: Number,
        }
    },
    methods : {
        ReformatNumber,
        GetReferenceLetter,
        IsAllChildrenForProcure(element) {
            let isOnProcurement = true;
            if(element.childs.length === 0) return false;
            
            for(let x = 0; x < element.childs.length; x++) {
                const child = element.childs[x];
                if(!child.forProcurement) {
                    isOnProcurement = false;
                    break;
                }
            }

            return isOnProcurement;
        },
        OnDragEnd(e){
            if(this.Level==3){
                // Check if the target is a parent or child element
                if (!e.to.classList.contains("last")) {
                    return false
                }
            }
            else if(this.Level==2){
                // Check if the target is a parent or child element
                if (!e.to.classList.contains("child")) {
                    return false
                }
            }
            else if(this.Level==1){
                // Check if the target is a parent or child element
                if (!e.to.classList.contains("parent")) {
                    return false
                }
            }
            
        },
        onEndDrag(){
            this.OnEnd()
            
        }
    },
    data(){
        return {
            options : {
                group: 'nested',
            },
            breakdownTo : {},
            BoqBuilderColumSizes,
        }
    }
}

</script>
